export function combineQueryStrings(
    ...queryStrings: (string | undefined)[]
): string {
    return queryStrings.reduce((acc: string, val) => {
        if (val) {
            if (acc !== '' && acc[acc.length - 1] !== '&' && val !== '') {
                acc += '&';
            }
            acc += val;
        }
        return acc;
    }, '');
}
